import React from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';
import i18n from 'locales/i18n';

export interface AppSidebarItemProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  onSidebarItemClick: () => void;
  href?: string;
  additionalClassName?: string;
  bold?: boolean;
  hasNestedRoutes?: boolean;
}

export const AppSidebarItem: React.FC<AppSidebarItemProps> = ({
    children,
  icon: Icon,
  href,
  title,
  onSidebarItemClick,
  additionalClassName,
  bold = false,
  hasNestedRoutes = false,
}) => {
  const direction = i18n.dir();

  const classes = useStyles({ direction });
  const location = useLocation();

  const isActive = React.useMemo(
    () => href && (hasNestedRoutes ? location.pathname.includes(href) : location.pathname === href),
    [location, hasNestedRoutes, href]
  );

  return (
    <Button
      className={clsx(classes.listItem, {
        [classes.listItemActive]: isActive,
        ...(additionalClassName ? { [additionalClassName]: !!additionalClassName } : null),
      })}
      onClick={onSidebarItemClick}
    >
      <div className={classes.itemIcon}>
        <Icon />
      </div>
      <Typography className={clsx(classes.itemText, { [classes.itemTextDashboard]: bold })} variant="h5">
        {title}
      </Typography>
      {children}
    </Button>
  );
};
